import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/ci`;

export const ciApi = axios.create({ baseURL: BASE });

ciApi.interceptors.request.use((config) => {
  const code = sessionStorage.getItem("ci_access_code");
  if (code) config.headers["X-CI-Access-Code"] = code;
  return config;
});

export const hasCIAccess = () => !!sessionStorage.getItem("ci_access_code");

export const verifyCICode = async (code) => {
  await axios.post(`${BASE}/auth/verify`, { code });
  sessionStorage.setItem("ci_access_code", code);
};

export const clearCIAccess = () => sessionStorage.removeItem("ci_access_code");
